import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { CAB_RFID_READER_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { CAB_RFID_READER_REPORT } from "../interfaces/dashboard";

export default function CabRFIdReader() {
    const cabRFIDReaderReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.CAB_RFID_READER_REPORT;

    const [cabRFIDReaderReportTableData, setCabRFIDReaderReportTableData] = useState<CAB_RFID_READER_REPORT[]>([]);

    useEffect(() => {
        setCabRFIDReaderReportTableData(CAB_RFID_READER_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="CAB_RFID_READER"
        tableColumns={cabRFIDReaderReportTableColumns}
        tableData={cabRFIDReaderReportTableData} />
    );
}